var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-column h-100 sidebar bg-trans-gradient" },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-grow-1 align-items-center justify-content-center",
        },
        [
          _c("router-link", { attrs: { to: { name: "portal.home" } } }, [
            _c("img", {
              attrs: {
                src: _vm.assetsPathGlobalPlatform("/logo.svg"),
                alt: "",
              },
            }),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "side-footer d-flex justify-content-center align-items-center",
        },
        [
          _c(
            "a",
            { attrs: { href: "https://www.municipia.pt", target: "_blank" } },
            [_c("img", { attrs: { src: _vm.logoIcon, alt: "" } })]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }